// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-review-workspace.ant-layout{height:100%}.cvat-issue-control{font-size:40px}.cvat-issue-control.cvat-disabled-canvas-control::after{opacity:.3}.cvat-issue-control::after{content:\"﹖\";font-size:32px;position:absolute;bottom:8px;right:-8px}", ""]);
// Exports
module.exports = exports;
